import { createBrowserRouter } from 'react-router-dom';
import Acquisitions from './app/pages/Acquisitions';
import Layout from './app/components/Layout';
import Main from './app/pages/MainPage';
import Platform from './app/pages/Platform';
import Solutions from './app/pages/Solutions';
import About from './app/pages/About';
import NotFoundPage from './app/pages/404';

const routes = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Main />,
      },
      {
        path: '/about',
        element: <About />,
      },
      {
        path: '/acquisitions',
        element: <Acquisitions />,
      },
      {
        path: '/solutions',
        element: <Solutions />,
      },
      {
        path: '/platform',
        element: <Platform />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export default routes;
